import React from 'react'
import {
  RacingDisabledOverlayStyled,
  MessageStyled,
  NotInVenueParentStyled,
  RacingContentStyled,
  RacingWrapperStyled,
  RacingOverlayStyled,
  RacingContainerStyled,
} from './Racing.styles'
import { RacingEvents } from '@core/Areas/VenueMode/Components/Racing/RacingEvents'
import { useVenueModeRacingEvents } from '@core/Areas/VenueMode/Components/Racing/Data/api'
import { BettingDrawer } from '@core/Components/BettingDrawer'
import {
  RacingEventType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'
import { betSelection } from '@core/Areas/VenueMode/Components/Racing/helpers/betSelection'
import { RacingNoExclusives } from '@core/Areas/VenueMode/Components/Racing/RacingNoExclusives'
import { LockIcon } from '@core/Areas/VenueMode/Components/Shared/LockIcon'
import { ErrorMessageStyled } from '@core/Components/Messages/Messages.styles'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { getCoords } from '@core/Areas/VenueMode/Store'
import { useSelector } from 'react-redux'
import { VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'

interface SelectedItem {
  proposition: RacingPropositionType
  event: RacingEventType
}
export const Racing: React.FC = () => {
  const { isLoading, isError, data: venueModeEvents } = useVenueModeRacingEvents()
  const [selectedItem, setSelectedItem] = React.useState<SelectedItem | null>(null)
  const outsideEventCount = useFeature(FeatureFlags.VENUE_MODE_OUTSIDE_EVENT_COUNT.key)
  const geoLocation = useSelector(getCoords)

  // We only consider user to be inside if location is also on
  const isInside = geoLocation.closestVenue?.inside == true

  function selectedItemChanged(proposition: RacingPropositionType, event: RacingEventType) {
    if (proposition.sequence == selectedItem?.proposition.sequence) setSelectedItem(null)
    else setSelectedItem({ proposition, event })
  }

  async function handleAddSelection(isQuickBet: boolean) {
    if (!selectedItem) return

    await betSelection(selectedItem.proposition, selectedItem.event, isQuickBet)
    setSelectedItem(null)
  }

  if (isLoading || venueModeEvents == null) {
    return <LoadingPlaceholder width='95%' height='3.4rem' margin='20px 0px 0px 10px' />
  }

  if (isError) {
    return (
      <ErrorMessageStyled>
        {`Unable to retrieve ${VENUE_FEATURE_NAME}. Please try again later.`}
      </ErrorMessageStyled>
    )
  }

  return (
    <RacingContainerStyled>
      {!venueModeEvents.length ? (
        <RacingNoExclusives />
      ) : (
        <>
          <RacingWrapperStyled>
            <RacingContentStyled disabled={!isInside}>
              <RacingEvents
                events={venueModeEvents}
                eventsDisplayCount={isInside ? undefined : outsideEventCount}
                selectedItem={selectedItem?.proposition ?? null}
                onSelectedItemChanged={selectedItemChanged}
              />
            </RacingContentStyled>

            {!isInside && (
              <>
                <RacingDisabledOverlayStyled />
                <RacingOverlayStyled>
                  <NotInVenueParentStyled>
                    <LockIcon />
                    <MessageStyled>
                      Head to your nearest venue to unlock exclusive offers
                    </MessageStyled>
                  </NotInVenueParentStyled>
                </RacingOverlayStyled>
              </>
            )}
          </RacingWrapperStyled>

          <BettingDrawer
            open={!!selectedItem}
            handleQuickbetClick={() => handleAddSelection(true)}
            handleAddToBetslipClick={() => handleAddSelection(false)}
          />
        </>
      )}
    </RacingContainerStyled>
  )
}
